// extracted by mini-css-extract-plugin
export default {"root":"root___fLb4l","copy_link":"copy_link___fQXLs","img":"img___SlAEX"};